import React from "react";
import { getPackageSpeedRows } from "./packageSpeed";

export { getPackageSpeedRows } from "./packageSpeed";

const PackageSpeedDisplay = ({
  packageInfo,
  legacyRateUnit,
  className,
  component: Component = "p",
  renderRow,
  suffix,
}) => {
  const rows = getPackageSpeedRows(packageInfo, { legacyRateUnit });

  if (rows.length === 0) {
    return null;
  }

  if (renderRow) {
    return rows.map(renderRow);
  }

  return (
    <Component className={className}>
      {rows.map((row, index) => (
        <React.Fragment key={row.direction}>
          {index > 0 ? <br /> : null}
          {row.label}: {row.value}
        </React.Fragment>
      ))}
      {suffix}
    </Component>
  );
};

export default PackageSpeedDisplay;
